module.exports = __webpack_public_path__ + "static/media/group-10.fc2a16f5.svg";